module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/433.68ebc668.png";